import { Component} from '@angular/core';
import { SharedServiceRegistry } from './../../../shared-service-registry';
import { CoreServiceRegistry } from './../../../../core/core-service-registry';
import { AlertService, LoaderEnabled, ResourceService } from 'sce-core';
import { SearchService } from './../../../search/search.service';
import { SearchParams } from './../../../search/models/search-params.model';
import { SearchStatus } from './../../../search/models/search-status.model';
import { ButtonItem } from '../../../button/button.model';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchableEntityDataEditorService } from '../../../services/searchable-entity/searchable-entity-data-editor.service';
import { REFRESH_SEARCH_EVENT } from '../../../search/search-constants';
import { SearchEvent } from '../../../search/models/search-event';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'lfwms-user-define-popup',
  templateUrl: './user-define-popup.component.html',
  styleUrls: ['./user-define-popup.component.css']
})
export class UserDefinePopupComponent {
  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  public isLoading: boolean = true;
  public searchService: SearchService;
  public resourceService: ResourceService;
  public tableMode = "V";
  public buttonPanelButtonArray = [
    new ButtonItem('Edit', this.coreServiceRegistry.resourceService.get('btn_edit'), 'assgn_veh_edit', 'pencil', []),
    new ButtonItem('Save', this.coreServiceRegistry.resourceService.get('btn_save'), '', 'floppy-disk', []),
    new ButtonItem('Copy Value To All Rows', this.coreServiceRegistry.resourceService.get('btn_copy_value_to'), '', 'copy', [])
  ];
  private http$ = this.coreServiceRegistry.http$;
  constructor(private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    public alertService: AlertService) {
    this.resourceService = coreServiceRegistry.resourceService;
  }
  public initializeComponents(searchCriteria: any) {
    this.refreshButtons();
    this.searchParams = new SearchParams();
    this.searchParams.tableId = 'transferuserdefinetd';
    this.searchParams.tableEditor = new SearchableEntityDataEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    this.searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.buttonPanelButtonArray);
    this.searchParams.isFullFetch = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.editable = true;
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;  // hide filter input boxes in header
    this.searchParams.dataTableConfig = tableConfig;
    this.searchStatus = new SearchStatus();
    this.searchService = this.sharedServiceRegistry
      .createSearchService(this.searchParams, this.searchStatus);
    this.searchService.fetchMetadata()
      .subscribe((data) => {
        console.log({ data });
        this.searchService.setSearchCriteria(searchCriteria);
        this.searchService.performSearch();
        this.isLoading = false;
      });
  }
  public handleButtonAction(action: string) {

    if (action === 'Edit') {
      this.tableMode = 'E';
      this.refreshButtons();
    } else if (action === 'Save') {
      this.save();
    } else if (action === 'Copy Value To All Rows') {
      this.copyValue();
    }
  }
  
  copyValue() {
    this.tableMode = 'V';
    let selectedColumnToCopy = '';
    const confirmDialogService = this.sharedServiceRegistry.confirmDialogService;
    if (this.searchService.getAllRows().length === 0) {
      this.alertService.clearAll().error(this.resourceService.get("no columns"));
      return false;
    }
    if (this.searchService.getFocusedRow().cName) {
      selectedColumnToCopy = this.searchService.getFocusedRow().cName;
    }
    const msgNoFocusRow: string = 'msg_clik_cell_to_copy_value';
    const msgCantCopyField: string = 'msg_cant_copy_field';

    if (!selectedColumnToCopy || (selectedColumnToCopy === 'isSelected')) {
      this.alertService.clearAll().error(this.resourceService.get(msgNoFocusRow));
      return;
    }
    const displayTypeSelectedField =
      this.searchService.getMetadataForProperty(selectedColumnToCopy).displayType;

    if (displayTypeSelectedField === 'V') {
      this.alertService.clearAll().error(this.resourceService.get(msgCantCopyField));
      return;
    }
    let valueToCopy = '';
    if (this.searchService.getFocusedRow().row) {
      valueToCopy = this.searchService.getFocusedRow().row.cells[selectedColumnToCopy].cVal;
    }

    const dialogMsg = this.resourceService.get('msg_copy_colmn') + this.resourceService.get(selectedColumnToCopy)
      + this.resourceService.get('msg_to_all_rows') + this.resourceService.get(selectedColumnToCopy)
      + this.resourceService.get('msg_overwrt');
    confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {         
          this.searchService.getPagedData().pageRows.forEach((lineItemRows: any) => {
            const lineItemCells = lineItemRows.cells;
            lineItemCells[selectedColumnToCopy].cVal = valueToCopy;
            lineItemRows.isEdited = true;
          });
          this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
        }
      });
  }
  save() {    
    let detailItems = [];
    const pagedRows = this.searchService.getEditedRows();
    const allRows = this.searchService.getAllRows();
    detailItems = this.getLineItemsForSaveRequest(pagedRows);
    if (allRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (pagedRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_mod'));
      this.coreServiceRegistry.navigationService.preventNavigation = false;
      this.tableMode = 'V';
      this.refreshButtons();
      return;
    }
    const finalSaveData: Array<any> = [];
    pagedRows.forEach((row: any) => {
      const moduleData = [];
      const rowDataArray: any = row['cells'];
      let privilege = "vas_trnsfr_dtl_user_define";
      Object.keys(rowDataArray).forEach((element: any) => {
        if (rowDataArray[element].cName !== 'transferLineNum') {
          if (rowDataArray[element].cName === 'transferKey') {
            const transferkeyOldValue: any = {
              'cName': 'original_' + rowDataArray[element].cName,
              'cVal': rowDataArray[element].cValOrig
            }
            const transferkeyValue: any = {
              'cName': rowDataArray[element].cName,
              'cVal': rowDataArray[element].cValOrig
            };
            moduleData.push(transferkeyOldValue);
            moduleData.push(transferkeyValue);

          }
          else {
            const moduleOldValue: any = {
              'cName': 'original_xfr' + rowDataArray[element].cName,
              'cVal': rowDataArray[element].cValOrig
            };
            const moduleNewValue: any = {
              'cName': 'xfr' + rowDataArray[element].cName,
              'cVal': rowDataArray[element].cValOrig
            };
            moduleData.push(moduleOldValue);
            moduleData.push(moduleNewValue);
          }
        }
      });
      finalSaveData.push({
        'moduleProperties': moduleData,
        'screenType': "transfertd",
        'detailItems': detailItems,
        'privilege': privilege
      });
    });

    this.saveDataBackendCall(finalSaveData)
      .subscribe((resp: any) => {
        if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            // code to reload the  detail grid
            this.alertService.clearAll();
            this.alertService.success(this.resourceService.get('msg_save_succ'));
            this.coreServiceRegistry.navigationService.preventNavigation = false;
            this.tableMode = 'V';
            this.refreshButtons();
            this.searchService.performSearch();
          } else {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
  }
  @LoaderEnabled()
  public saveDataBackendCall(request) {
    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(request))
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }        
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.status === 403) {
            return Observable.throw(error.error.message);
          } else if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }
  public getLineItemsForSaveRequest(lineItems) {
    const detailItemsForSave = [];
    const detailData = [];
    lineItems.forEach(row => {
      const cellsKeyArray = Object.keys(row.cells);
      const keyValueList = [];
      cellsKeyArray.forEach(key => {
        //keyValueList.push({ 'cName': key, 'cVal': row.cells[key].cVal });
        const detailOldValue: any = {
          'cName': 'original_' + key,
          'cVal': row.cells[key].cValOrig
        };
        const detailNewValue: any = {
          'cName': key,
          'cVal': row.cells[key].cVal
        };
        keyValueList.push(detailOldValue);
        keyValueList.push(detailNewValue);

      });
      detailItemsForSave.push({
        'rIdx': detailItemsForSave.length,
        'cells': keyValueList
      });
    });
    return detailItemsForSave;
  }
  refreshButtons() {
    this.buttonPanelButtonArray.forEach((button: ButtonItem) => {
      switch (button.action) {
        case 'Edit': {
          button.isEnabled = (this.tableMode === 'V');
          button.isVisible = (this.tableMode === 'V');
          break;
        }
        case 'Save': {
          button.isEnabled = (this.tableMode === 'E');
          button.isVisible = (this.tableMode === 'E');
          break;
        }
        case 'Copy Value To All Rows': {
          button.isEnabled = (this.tableMode === 'E');
          button.isVisible = (this.tableMode === 'E');
          break;
        }
      }
    });
  }
 
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/userdefinefields-popup/user-define-popup.component.ts